require('./constants');
const ReportTypeInternal = require('./reportTypeInternal');

// Import this files instead of reportTypeInternal.js to make sure byReportType etc are popuplated,
// except for log report types

module.exports = ReportTypeInternal;
